import { useState } from 'react';
import { Link, useSearchParams } from 'react-router';
import { api, errorMessage } from '../api/client';
import { Spinner } from '../components/ui';
import { useAuth } from '../state/auth';
import { AuthShell } from './AuthPages';

/**
 * The "Unsubscribe" link in product update emails. Nothing happens until the button is pressed:
 * mail scanners open every link in an email, and that must not unsubscribe anyone.
 */
export function UnsubscribePage() {
  const [params] = useSearchParams();
  const u = params.get('u');
  const t = params.get('t');
  const { user, setUser } = useAuth();
  const [state, setState] = useState<'ready' | 'working' | 'done' | 'error'>(u && t ? 'ready' : 'error');
  const [error, setError] = useState(u && t ? '' : "This link isn't complete. Copy the whole link from the email, or turn update emails off in your account settings.");

  const stop = async () => {
    setState('working');
    try {
      await api.post('/email/unsubscribe', { u, t });
      setState('done');
      if (user && user.id === u) setUser({ ...user, updateEmails: false });
    } catch (err) {
      setState('error');
      setError(errorMessage(err));
    }
  };

  return (
    <AuthShell title="Product update emails" subtitle={state === 'ready' || state === 'working' ? 'We email you when a product you own or are trying gets a new version.' : undefined}>
      {(state === 'ready' || state === 'working') && (
        <button className="btn btn-primary btn-block" disabled={state === 'working'} onClick={stop}>
          {state === 'working' ? <Spinner /> : 'Stop product update emails'}
        </button>
      )}
      {state === 'done' && (
        <div className="stack">
          <div className="form-ok">Done. You won't get product update emails anymore. You can turn them back on in your account settings.</div>
          <Link className="btn btn-outline btn-block" to="/account">Account settings</Link>
        </div>
      )}
      {state === 'error' && (
        <div className="stack">
          <div className="form-error">{error}</div>
          <Link className="btn btn-outline btn-block" to="/account">Account settings</Link>
        </div>
      )}
    </AuthShell>
  );
}
